// PaymentSuccess.jsx
import React from 'react';
import '../styles/paymentStyle.css';

const PaymentSuccess = () => {
  return (
    <div className="payment-container">
      <div className="content-wrapper">
        {/* Detalles de la Factura */}
        <div className="invoice-card">
          <h2 className="card-title">Detalles de la Factura</h2>
          
          <div className="invoice-details">
            <div className="detail-row">
              <span className="detail-label">Fecha y hora de expedición:</span>
              <span className="detail-value">01-09-2020 08:24pm</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Fecha y hora de pago:</span>
              <span className="detail-value">01-09-2020 08:26 pm</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Nombre de la factura:</span>
              <span className="detail-value">Canita Terms</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Plaza a la que se le adjunta pago:</span>
              <span className="detail-value">Las 397</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Medio vehiculo:</span>
              <span className="detail-value">Nissan</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Modelo vehiculo:</span>
              <span className="detail-value">Sentra</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Monto total pagado:</span>
              <span className="detail-value">$3,000.00 MXN</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Estado:</span>
              <span className="detail-value status-pending">pendiente</span>
            </div>
          </div>
          
          <div className="payment-method-section">
            <p className="payment-method-label">Seleccione método de pago</p>
            <div className="payment-buttons">
              <button className="payment-btn payment-btn-card active">
                <i className="icon">💳</i> PAGO
              </button>
              <button className="payment-btn payment-btn-paypal">
                <i className="icon">📱</i> PAJ
              </button>
            </div>
          </div>
        </div>

        {/* Confirmación de Pago */}
        <div className="success-card">
          <div className="success-icon">
            <div className="receipt-icon">
              <div className="checkmark">✓</div>
            </div>
          </div>
          
          <h2 className="success-title">¡Pago éxitoso!</h2>
          <p className="success-message">Tu pago ha sido procesado correctamente</p>
          
          <div className="action-buttons">
            <button className="action-btn qr-btn">
              <div className="qr-icon">
                <div className="qr-code"></div>
                <span>Ver QR</span>
              </div>
            </button>
            <button className="action-btn download-btn">
              <i className="download-icon">⬇</i>
              <span>Descargar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;